document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-load-more-button]');
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();

  if (button.disabled) return;

  const section = button.closest('results-list[section-id]');
  const wrapper = button.closest('[data-load-more-wrapper]');
  const grid = section?.querySelector('.custom-product-grid__list');

  if (!section || !wrapper || !grid) return;

  const nextUrl = button.dataset.nextUrl;
  const sectionId = section.getAttribute('section-id');

  if (!nextUrl || !sectionId) return;

  const defaultLabel = button.dataset.defaultLabel || button.textContent.trim() || 'Mehr laden';
  const loadingLabel = button.dataset.loadingLabel || 'Lädt …';
  const retryLabel = button.dataset.retryLabel || 'Erneut versuchen';

  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.textContent = loadingLabel;

  try {
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);

    const response = await fetch(url.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const incomingSection =
      doc.querySelector(`results-list[section-id="${sectionId}"]`) || doc;
    const incomingGrid = incomingSection.querySelector('.custom-product-grid__list');

    if (!incomingGrid) {
      throw new Error('Incoming grid not found');
    }

    const incomingCards = incomingGrid.querySelectorAll('.custom-product-grid__item');

    if (!incomingCards.length) {
      wrapper.remove();
      return;
    }

    incomingCards.forEach((card) => {
      grid.appendChild(card.cloneNode(true));
    });

    const incomingLoadMoreButton = incomingSection.querySelector('[data-load-more-button]');

    if (
      incomingLoadMoreButton instanceof HTMLButtonElement &&
      incomingLoadMoreButton.dataset.nextUrl
    ) {
      button.dataset.nextUrl = incomingLoadMoreButton.dataset.nextUrl;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = defaultLabel;
    } else {
      wrapper.remove();
    }
  } catch (error) {
    console.error('Custom product grid load more failed:', error);
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.textContent = retryLabel;
  }
});